import AppConfig from 'config'
import { CameraType } from 'expo-camera'
import { create } from 'zustand'

export type DevToggles = {
  idleLogout: boolean
  qrCameraType: CameraType
  measurementsMock: boolean
  dealTypes: string | undefined
  avatar: boolean | undefined
}

export type DevToggle = keyof DevToggles

type DevTogglesState = DevToggles & {
  toggle: (name: DevToggle, value: DevToggles[DevToggle]) => void
}

export const useDevToggles = create<DevTogglesState>((set) => ({
  idleLogout: false,
  qrCameraType: 'front',
  measurementsMock: false,
  dealTypes: undefined,
  avatar: undefined,
  toggle: (name, value) => set(() => ({ [name]: value })),
}))

/**
 * Wrapper to make sure dev toggles don't get used outside of dev mode
 *
 * Always returns the fallback value if not in dev mode
 */
export const resolveDevToggle = <F>(value: F | undefined, fallback: F) => {
  if (!AppConfig.isDev) {
    return fallback
  }

  return value ?? fallback
}
